/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

let authredirectUri = ""
 if(process.env.NODE_ENV === "development"){
    authredirectUri = "http://localhost:3000/"
 }else{
    authredirectUri = "https://signup.contactsmanager.com"
}
console.log('365APPS ~ authredirectUri', authredirectUri);

export const msalConfig = {
    auth: {

        authority: "https://login.microsoftonline.com/organizations",
        clientId: "2275fb73-797b-4629-8718-a448bf8d4817",
        redirectUri: authredirectUri,
        // redirectUri: "http://localhost:3000/",
        // authority: "https://login.microsoftonline.com/common/",
        // authority: "https://login.microsoftonline.com/organizations",

        //  redirectUri: "https://localhost:3000",
        // clientId:       process.env.AZURE_CLIENT_ID, // The application (client) ID registered in the AAD tenant
        // authority: "https://login.microsoftonline.com/common/",        // // redirectUri: "https://signup.contactsmanager.com"
        //  redirectUri: process.env.REACT_APP_REDIRECTURI
        
        //"http://localhost:3000/"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored THIS ENABLES 
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                         console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        //  console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        //  console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                         console.warn(message);		
                        return;		
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: ["User.Read","User.Read.All"]
    scopes: ["User.Read"]
};
export const loginRequest2 = {
    // scopes: ["User.Read","User.Read.All"]
    scopes: ["User.Read.All"]
};


/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphUsers: "https://graph.microsoft.com/v1.0/users"
};
